/* Scoop: "Shop by diet" bar. Turns the Dietary filter into one-tap buttons above the product grid.
   Reads the options, counts and ticked state from Shopify's own Dietary filter, so it always matches. */
(function () {
  var ICONS = {
    'gluten free': '<path d="M12 21V9"/><path d="M12 9c-2.2 0-3.5-1.6-3.5-3.8C10.7 5.2 12 6.8 12 9Zm0 0c2.2 0 3.5-1.6 3.5-3.8C13.3 5.2 12 6.8 12 9Z"/><path d="M12 14c-2.2 0-3.5-1.6-3.5-3.8 2.2 0 3.5 1.6 3.5 3.8Zm0 0c2.2 0 3.5-1.6 3.5-3.8-2.2 0-3.5 1.6-3.5 3.8Z"/><path d="M4 4l16 16"/>',
    'dairy free': '<path d="M9 3h6v3l2 3v11a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V9l2-3z"/><path d="M7 12h10"/><path d="M4 4l16 16"/>',
    'vegan': '<path d="M5 19c0-8 5-13 14-14-1 9-6 14-14 14Z"/><path d="M5 19 13 11"/>',
    'vegetarian': '<path d="M12 21v-8"/><path d="M12 13c0-3.5-2.5-6-6-6 0 3.5 2.5 6 6 6Z"/><path d="M12 11c0-3.5 2.5-6 6-6 0 3.5-2.5 6-6 6Z"/>',
    'no added sugar': '<rect x="6" y="7" width="12" height="12" rx="1.5"/><path d="M6 11h12M12 7v12"/><path d="M4 4l16 16"/>',
    'nut free': '<path d="M12 4c3.9 0 6 3 6 7.5S15.3 20 12 20s-6-4-6-8.5S8.1 4 12 4Z"/><path d="M9.5 9.5c1.5-.8 3.5-.8 5 0"/><path d="M4 4l16 16"/>',
    'organic': '<circle cx="12" cy="12" r="8"/><path d="M8.5 12.5c0-3 2-5 5.5-5.5-.3 3.6-2.3 5.7-5.5 5.5Z"/>',
    'keto': '<path d="M12 3l7 4v10l-7 4-7-4V7z"/><path d="M12 8v8"/>'
  };
  /* Each diet is its own yes/no filter, so picking two diets shows products that meet both. */
  var DIETS = [
    ['gluten_free', 'Gluten Free'], ['dairy_free', 'Dairy Free'], ['nut_free', 'Nut Free'],
    ['vegan', 'Vegan'], ['vegetarian', 'Vegetarian'], ['no_added_sugar', 'No Added Sugar'],
    ['grain_free', 'Grain Free'], ['caffeine_free', 'Caffeine Free'], ['contains_caffeine', 'Contains Caffeine']
  ];
  var DEFAULT_ICON = '<circle cx="12" cy="12" r="8"/><path d="M8.5 12l2.5 2.5 4.5-5"/>';

  var css = '' +
    '.sdiet{margin:0 0 2.4rem;padding:2.4rem 0 2.2rem;border-top:1px solid rgba(31,20,16,.1);border-bottom:1px solid rgba(31,20,16,.1)}' +
    '.sdiet__top{display:flex;align-items:baseline;justify-content:space-between;gap:1.6rem;margin-bottom:1.6rem}' +
    '.sdiet__k{font-size:1.15rem;font-weight:700;letter-spacing:.32em;text-transform:uppercase;color:#b1882f;display:inline-flex;align-items:center;gap:1.2rem}' +
    '.sdiet__k::before{content:"";width:28px;height:1px;background:currentColor}' +
    '.sdiet__clear{font-size:1.2rem;letter-spacing:.2em;text-transform:uppercase;font-weight:700;color:#7f2631;text-decoration:none;background-image:linear-gradient(#b1882f,#b1882f);background-repeat:no-repeat;background-position:0 100%;background-size:100% 1px;padding-bottom:.2rem}' +
    '.sdiet__clear[hidden]{display:none}' +
    '.sdiet__list{display:flex;flex-wrap:wrap;gap:1rem;list-style:none;margin:0;padding:0}' +
    '.sdiet__btn{display:inline-flex;align-items:center;gap:1rem;padding:1.1rem 2rem 1.1rem 1.4rem;border:1px solid rgba(31,20,16,.16);border-radius:999px;background:#fff;color:#1f1410;font:inherit;font-size:1.45rem;letter-spacing:.02em;line-height:1;cursor:pointer;text-decoration:none;white-space:nowrap;transition:border-color .3s,background-color .3s,color .3s,transform .3s cubic-bezier(.22,1,.36,1),box-shadow .3s;opacity:0;transform:translateY(8px);animation:sdiet-in .6s cubic-bezier(.22,1,.36,1) forwards;animation-delay:var(--d,0s)}' +
    '@keyframes sdiet-in{to{opacity:1;transform:none}}' +
    '.sdiet__btn svg{width:22px;height:22px;flex:0 0 22px;fill:none;stroke:#7f2631;stroke-width:1.4;stroke-linecap:round;stroke-linejoin:round;transition:stroke .3s}' +
    '.sdiet__n{font-size:1.15rem;color:#8a7a6e;letter-spacing:.04em;transition:color .3s}' +
    '.sdiet__btn:hover{border-color:#b1882f;transform:translateY(-2px);box-shadow:0 10px 24px rgba(31,20,16,.08)}' +
    '.sdiet__btn[aria-pressed="true"]{background:#7f2631;border-color:#7f2631;color:#fff}' +
    '.sdiet__btn[aria-pressed="true"] svg{stroke:#e8dbc1}' +
    '.sdiet__btn[aria-pressed="true"] .sdiet__n{color:#e8dbc1}' +
    '.sdiet__btn[aria-pressed="true"]::after{content:"";width:6px;height:6px;border-radius:50%;background:#b1882f;margin-left:.2rem}' +
    '.sdiet__btn[disabled]{opacity:.35!important;cursor:not-allowed;transform:none!important;box-shadow:none!important}' +
    '.sdiet__btn:focus-visible{outline:2px solid #b1882f;outline-offset:2px}' +
    '@media (max-width:749px){.sdiet{margin:0 -1.5rem 2rem;padding:2rem 0 1.8rem 1.5rem}.sdiet__top{padding-right:1.5rem}.sdiet__list{flex-wrap:nowrap;overflow-x:auto;scrollbar-width:none;padding-right:1.5rem;-webkit-mask-image:linear-gradient(to right,#000 85%,transparent);mask-image:linear-gradient(to right,#000 85%,transparent)}.sdiet__list::-webkit-scrollbar{display:none}.sdiet__btn{font-size:1.35rem;padding:1rem 1.6rem 1rem 1.2rem}}' +
    '@media (prefers-reduced-motion:reduce){.sdiet__btn{animation:none;opacity:1;transform:none}}' +
    /* The dropdown version is replaced by the buttons, so hide it on desktop. */
    '.facets__disclosure[id*="scoop.dietary"],details[id^="Details-filter.p.m.scoop.dietary"],details[id^="Details-Mobile-filter.p.m.scoop.dietary"]{display:none!important}' +
    DIETS.map(function (d) { return 'details[id^="Details-filter.p.m.scoop.' + d[0] + '"],details[id^="Details-Mobile-filter.p.m.scoop.' + d[0] + '"]'; }).join(',') + '{display:none!important}' +
    /* The pills row under Filter / Price repeats what the diet bar and Clear already do. */
    '.active-facets-desktop,.facets__form .active-facets{display:none!important}';

  function iconFor(label) {
    var k = label.toLowerCase().trim();
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' + (ICONS[k] || DEFAULT_ICON) + '</svg>';
  }

  function countOf(inp) {
    var m = ((inp.closest('li') || inp.parentNode).textContent || '').match(/\((\d+)\)/);
    return m ? m[1] : '';
  }

  /* Returns [{label, name, value, checked, disabled, count}] from whichever filters the store has. */
  function options() {
    var out = [];
    DIETS.forEach(function (d) {
      var box = document.querySelector('details[id^="Details-filter.p.m.scoop.' + d[0] + '"]') ||
                document.querySelector('details[id^="Details-Mobile-filter.p.m.scoop.' + d[0] + '"]');
      if (!box) return;
      var yes = [].filter.call(box.querySelectorAll('input[type="checkbox"]'), function (i) { return i.value === '1' || i.value === 'true'; })[0];
      if (!yes) return;
      out.push({ label: d[1], name: yes.name, value: yes.value, checked: yes.checked, disabled: yes.disabled, count: countOf(yes) });
    });
    if (out.length) return out;
    /* Fallback: the older single Dietary filter. */
    var src = document.querySelector('details[id^="Details-filter.p.m.scoop.dietary"]') ||
              document.querySelector('details[id^="Details-Mobile-filter.p.m.scoop.dietary"]');
    if (!src) return out;
    [].forEach.call(src.querySelectorAll('input[type="checkbox"]'), function (i) {
      out.push({ label: i.value, name: i.name, value: i.value, checked: i.checked, disabled: i.disabled, count: countOf(i) });
    });
    return out;
  }

  function build() {
    if (document.querySelector('.sdiet')) return;
    var opts = options();
    if (!opts.length) return;

    if (!document.getElementById('sdiet-css')) {
      var st = document.createElement('style'); st.id = 'sdiet-css'; st.textContent = css; document.head.appendChild(st);
    }

    var wrap = document.createElement('section');
    wrap.className = 'sdiet';
    wrap.setAttribute('aria-label', 'Shop by diet');
    var anyOn = opts.some(function (o) { return o.checked; });
    wrap.innerHTML = '<div class="sdiet__top"><span class="sdiet__k">Shop by diet</span><a href="#" class="sdiet__clear"' + (anyOn ? '' : ' hidden') + '>Clear</a></div><ul class="sdiet__list" role="list"></ul>';
    var ul = wrap.querySelector('ul');

    opts.forEach(function (o, i) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sdiet__btn';
      btn.style.setProperty('--d', (i * 0.05) + 's');
      btn.setAttribute('aria-pressed', o.checked ? 'true' : 'false');
      if ((o.disabled || o.count === '0') && !o.checked) btn.disabled = true;
      btn.innerHTML = iconFor(o.label) + '<span>' + o.label + '</span>' + (o.count ? '<span class="sdiet__n">' + o.count + '</span>' : '');
      btn.addEventListener('click', function () { go(o.name, o.value); });
      li.appendChild(btn);
      ul.appendChild(li);
    });

    wrap.querySelector('.sdiet__clear').addEventListener('click', function (e) {
      e.preventDefault();
      var p = new URLSearchParams(location.search);
      opts.forEach(function (o) { p.delete(o.name); });
      p.delete('page');
      location.search = p.toString();
    });

    var anchor = document.querySelector('.facets-container') || document.getElementById('ProductGridContainer');
    if (anchor) anchor.parentNode.insertBefore(wrap, anchor);
  }

  function go(name, value) {
    var p = new URLSearchParams(location.search);
    var vals = p.getAll(name);
    var on = vals.indexOf(value) > -1;
    p.delete(name);
    vals.forEach(function (v) { if (v !== value) p.append(name, v); });
    if (!on) p.append(name, value);
    p.delete('page');
    location.search = p.toString();
  }

  // Keep the buttons in step when other filters (price, sort) refresh the grid without a page load.
  var sig = '';
  function signature() {
    return options().map(function (o) { return o.name + o.value + o.checked + o.disabled + o.count; }).join('|');
  }
  function refresh() {
    var s = signature();
    if (s === sig && document.querySelector('.sdiet')) return;
    sig = s;
    var old = document.querySelector('.sdiet'); if (old) old.remove();
    build();
  }
  function start() {
    sig = signature();
    build();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(refresh, 150); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', refresh);
})();
